/**
 * Channels through which the system can communicate with guests.
 */
export enum CommunicationChannelEnum {
  /** WhatsApp messaging */
  WhatsApp = 'WhatsApp',
  /** SMS text messages */
  Sms = 'Sms',
  /** Voice phone calls */
  Phone = 'Phone',
  /** Internal alpha channel used for tests */
  Alpha = 'Alpha',
  /** Email messages */
  Email = 'Email',
  /**
   * @deprecated This value will be removed in favour of {@link CommunicationChannelEnum.SmartChat}.
   */
  WebChat = 'WebChat',
  /** Facebook messenger platform */
  FacebookMessenger = 'FacebookMessenger',
  /** SmartHotel's own chat channel */
  SmartChat = 'SmartChat',
  /** Telegram messenger */
  Telegram = 'Telegram',
  /** Signal messenger */
  Signal = 'Signal',
  /** Skype messenger */
  Skype = 'Skype',
  /** Booking.com extranet messaging */
  BookingCom = 'BookingCom',
  /** Airbnb messaging */
  AirBnB = 'AirBnB',
  /** Vrbo platform */
  Vrbo = 'Vrbo',
  /** Internal system communications */
  Internal = 'Internal',
  /** Push notifications */
  Push = 'Push',
}
